<template>
    <div class="abnormal">
        <Head-view :showStyle="6"></Head-view>
        <div class="main">
            <div class="breadcrumb">异常记录</div>
            <div class="nav">
                <div class="searchLeft">
                    <div class="searchBox">
                        <div class="fontName">巡检任务</div>
                        <div class="searchInp">
                            <el-select
                                v-model="taskId"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in taskArr"
                                    :key="item.taskId"
                                    :label="item.name"
                                    :value="item.taskId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fontName departName">巡检路线</div>
                        <div class="searchInp">
                            <el-select
                                v-model="routeId"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in routeArr"
                                    :key="item.routeId"
                                    :label="item.name"
                                    :value="item.routeId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fontName departName">巡检时间</div>
                        <div class="searchInp">
                            <el-date-picker
                                v-model="insoextionTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="getInspectTime"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="searchBox searchBoxBottom">
                        <div class="fontName">巡检状态</div>
                        <div class="searchInp">
                            <el-select
                                v-model="statusNum"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in statusArr"
                                    :key="item.number"
                                    :label="item.status"
                                    :value="item.number"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fontName departName">巡检员</div>
                        <div class="searchInp">
                            <el-select
                                v-model="staffId"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in staffArr"
                                    :key="item.staffId"
                                    :label="item.name"
                                    :value="item.staffId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fontName departName">巡检点位</div>
                        <div class="searchInp">
                            <el-select
                                v-model="placeId"
                                clearable
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in placeArr"
                                    :key="item.placeId"
                                    :label="item.name"
                                    :value="item.placeId"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="searchRight">
                    <div class="inspectionSearchBtn" @click="addrouters()">
                        搜索
                    </div>
                    <div
                        class="inspectionSearchBtn colorGreen"
                        @click="importInsp()"
                    >
                        导出
                    </div>
                </div>
            </div>

            <div class="showTba">
                <div class="bodyTable">
                    <el-table
                        :data="tableData"
                        style="width: 100%; max-height: 489px"
                        height="489px"
                        v-loading="loading"
                        stripe
                    >
                        <el-table-column label="路线图片" width="180">
                            <template slot-scope="scope">
                                <div class="headImg">
                                    <img
                                        v-if="scope.row.routePicture"
                                        :src="scope.row.routePicture"
                                        alt=""
                                    />
                                    <img
                                        v-if="!scope.row.routePicture"
                                        src="../../assets/routerDefaultImg.png"
                                        alt=""
                                    />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="taskName"
                            label="任务名称"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="routeName"
                            label="路线名称"
                            width="180"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="inspectStartTime"
                            label="开始时间"
                            width="200"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="inspectStopTime"
                            label="结束时间"
                            width="200"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="duration"
                            label="巡检时长"
                            width="130"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="staffName"
                            label="巡检员"
                            width="130"
                        >
                        </el-table-column>
                        <el-table-column label="巡检结果" width="160">
                            <template slot-scope="scope">
                                <div :class="scope.row.statusClass">
                                    {{ scope.row.statusFont }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="超时" width="120">
                            <template slot-scope="scope">
                                <div
                                    :class="[
                                        scope.row.isTimeout ? 'colorRed' : '',
                                    ]"
                                >
                                    <span v-if="scope.row.isTimeout">是</span>
                                    <span v-if="!scope.row.isTimeout">否</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="120">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleEide(scope.$index, scope.row)"
                                    type="text"
                                    size="small"
                                    class="colorBulr"
                                    >详情</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageObj.currentPage"
                        :page-sizes="pageObj.pageSizeArr"
                        :page-size="pageObj.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
import { getTime } from "../../untils/tools"
export default {
    name: "abnormal",
    data() {
        return {
            placeId: "",
            placeArr: [],

            taskId: "",
            taskArr: [],

            routeId: "",
            routeArr: [],

            staffId: "",
            staffArr: [],

            statusNum: "",
            statusArr: [
                {
                    status: "异常完成",
                    number: '3',
                },
                {
                    status: "漏检记录",
                    number: '4',
                },{
                    status: '超时记录',
                    number: '2,3'
                }
            ],
            tableData: [],

            insId: "",
            insoextionTime: "",
            pageObj: {
                currentPage: 1,
                pageSizeArr: [10, 40, 100, 400],
                pageSize: 10,
                total: 0,
            },

            loading: false,
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.abnormalInfo();

        this.getAllTaskList(); //任务
        this.getRouteInfo(); //路线
        this.rolePersonnelInfo(); //人员
        this.getAllPlace(); //点位
    },

    methods: {
        abnormalInfo() {
            this.loading = true;
            let startDate = "",
                stopDate = "";
            let statusNum = [2, 3, 4]
            
            if (this.insoextionTime) {
                startDate = getTime(2, this.insoextionTime[0]);
                stopDate = getTime(2, this.insoextionTime[1]);
            }
            if (this.statusNum != '') {
                statusNum = []
                this.statusNum.split(',').filter(item => {
                    statusNum.push(Number(item))
                })
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                page: this.pageObj.currentPage,
                limit: this.pageObj.pageSize,
                taskId: this.taskId,
                placeId: this.placeId,
                routeId: this.routeId,
                staffId: this.staffId,
                startDate: startDate,
                stopDate: stopDate,
                isTimeout: (this.statusNum == "" || this.statusNum == '2,3') ? true : false,
                status: statusNum,
            };
            this.request
                .post(this.baseUrl + "inspect/getTaskInspectRecordList", data)
                .then((res) => {
                    if (res.code == 0 && res.data.totalCount >= 0) {
                        let dataArr = [];
                        res.data.list.forEach((item, key) => {
                            dataArr.push(item);

                            dataArr[key]["statusFont"] = this.inspeStatus(
                                item.status
                            );
                            dataArr[key]["statusClass"] =
                                item.status != 3 && item.status != 4 ? "colorGreenFont" : "colorRed";
                        });
                        this.tableData = dataArr;
                        this.pageObj.total = res.data.totalCount;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }

                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message({
                        type: "warning",
                        message: "获取点位列表失败",
                    });
                });
        },

        getAllTaskList() {
            let data = {
                token: this.getCookie(),
                insId: this.insId,
            };
            this.request
                .post(this.baseUrl + "task/getAllTaskList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.taskArr = res.data;
                    }
                });
        },

        getRouteInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "route/getAllRouteList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.routeArr = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取部门失败",
                    });
                });
        },

        rolePersonnelInfo() {
            let data = {
                insId: this.insId,
                token: this.getCookie(),
            };
            this.request
                .post(this.baseUrl + "institution/getAllStaffList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.staffArr = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: "获取人员失败",
                    });
                });
        },

        getAllPlace() {
            //获取点位管理
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                keyword: "",
            };
            this.request
                .post(this.baseUrl + "place/getAllPlaceList", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.placeArr = res.data;
                    } else {
                        this.$message({
                            type: "waring",
                            message: res.msg,
                        });
                    }
                });
        },

        importInsp() {
            let startDate = this.insoextionTime[0] ? getTime(2, this.insoextionTime[0]) : '',
                stopDate = this.insoextionTime[1] ? getTime(2, this.insoextionTime[1]) : '';
            
            let statusNum = [2, 3, 4]
            if (this.statusNum != '') {
                statusNum = []
                this.statusNum.split(',').filter(item => {
                    statusNum.push(Number(item))
                })
            }
            let data = {
                token: this.getCookie(),
                insId: this.insId,
                taskId: this.taskId,
                routeId: this.routeId,
                placeId: this.placeId,
                staffId: this.staffId,
                startDate: startDate,
                stopDate: stopDate,
                status: statusNum,
                isTimeout: this.statusNum == '2,3' ? true : false
            };
            this.request.post(this.baseUrl + "inspect/exportTaskInspectRecordList", data)
                .then((res) => {
                    if (res.code == 0) {
                        let a = document.createElement('a')
                        a.href = res.data.url
                        let event = new MouseEvent('click')
                        a.dispatchEvent(event)
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.msg
                        })
                    }
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: '请求过于频繁,请稍后再试'
                    })
                });
        },

        searchBtn() {
            // this.personnelInfo()
        },

        addrouters() {
            this.abnormalInfo()
        },
        handleSizeChange(val) {
            this.pageObj.pageSize = val;
            this.abnormalInfo();
        },
        handleCurrentChange(val) {
            this.pageObj.currentPage = val;
            this.abnormalInfo();
        },
        handleEide(index, row) {
            this.$router.push({
                path: "/abnormal/abnormalMsg",
                query: {
                    id: row.taskInspectRecordId
                },
            });
        },

        getInspectTime(e) {
            let timeSpan = 92 * 24 * 60 * 60 * 1000
            let startTime = e[0].getTime()
            let endTime = e[1].getTime()
            if ((endTime - startTime) > timeSpan) {
                endTime = startTime + timeSpan
                this.insoextionTime[1] = new Date(endTime)
                this.$message({
                    type: "warning",
                    message: "选择的时间跨度不能超过三个月"
                })
            }
        },

        inspeStatus(key) {
            //1-巡检中 2-已完成-正常 3-已完成-异常 4-漏检
            switch (key) {
                case 1:
                    return "巡检中";
                case 2:
                    return "巡检正常";
                case 3:
                    return "巡检异常";
                case 4:
                    return "漏检";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.abnormal {
    height: 100vh;

    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        .breadcrumb {
            margin-left: 7px;
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
        }
        .nav {
            margin-top: 24px;
            margin-left: 7px;
            height: 126px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            overflow: hidden;
            .searchLeft {
                float: left;
                margin: 12px 0 0 20px;
                height: 126px;
                background: rgba(255, 255, 255, 1);
                border-radius: 4px;

                .searchBox {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                }
                .searchBoxBottom {
                    margin-top: 20px;
                }
                .fontName {
                    width: 72px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    line-height: 40px;
                }
                .searchInp {
                    width: 211px;
                }
                .departName {
                    padding: 0 5px 0 15px;
                    color: rgba(48, 49, 51, 1);
                    font-size: 14px;
                    line-height: 14px;
                    font-weight: 400;
                    text-align: center;
                    line-height: 40px;
                }
                .searchBtn {
                    margin-left: 20px;
                    width: 68px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }

            .searchRight {
                float: right;
                margin: 17px 17px 0 0;
                padding-left: 40px;
                border-left: 1px solid rgba(166, 166, 166, 1);
            }

            .inspectionSearchBtn {
                width: 68px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                background: rgba(4, 134, 254, 1);
                border-radius: 4px;
                color: rgba(255, 255, 255, 1);
                font-size: 14px;
                font-weight: 500;
                cursor: pointer;
            }

            .colorGreen {
                margin-top: 15px;
                background-color: rgba(103, 194, 58, 1);
            }
        }
        .showTba {
            margin-top: 24px;
            margin-right: 7px;
            padding: 16px 17px 0 31px;
            height: 618px;
            background: #fff;
            .bodyTable {
                width: 100%;
                height: 500px;
                overflow: hidden;
                overflow-y: auto;
                .headImg {
                    width: 78px;
                    height: 78px;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
            }
            .pageination {
                margin-top: 69px;
                text-align: right;
            }
        }

        .colorRed {
            color: rgba(255, 87, 51, 1);
        }

        .colorBulr {
            color: rgba(25, 137, 250, 1);
        }

        .colorGreenFont {
            color: rgba(67, 207, 124, 1) !important;
        }
    }
}
</style>